export default "__VITE_ASSET__1223b6b6__"